/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';

/**
 * 
 * @export
 * @interface InternalApiScreeningFlowTestRun
 */
export interface InternalApiScreeningFlowTestRun {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningFlowTestRun
     */
    screeningTestId: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlowTestRun
     */
    status: string;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiScreeningFlowTestRun
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningFlowTestRun
     */
    minId: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningFlowTestRun
     */
    maxId: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningFlowTestRun
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningFlowTestRun
     */
    startedTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningFlowTestRun
     */
    durationMs?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningFlowTestRun
     */
    selectionMode?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScreeningFlowTestRun
     */
    externalEntityIds?: Array<string> | null;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningFlowTestRun
     */
    fromTime?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningFlowTestRun
     */
    toTime?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningFlowTestRun
     */
    goodlistEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningFlowTestRun
     */
    useOnlyScreenedEntities?: boolean;
}



/**
 * Check if a given object implements the InternalApiScreeningFlowTestRun interface.
 */
export function instanceOfInternalApiScreeningFlowTestRun(value: object): value is InternalApiScreeningFlowTestRun {
    if (!('screeningTestId' in value) || value['screeningTestId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('minId' in value) || value['minId'] === undefined) return false;
    if (!('maxId' in value) || value['maxId'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function InternalApiScreeningFlowTestRunFromJSON(json: any): InternalApiScreeningFlowTestRun {
    return InternalApiScreeningFlowTestRunFromJSONTyped(json, false);
}

export function InternalApiScreeningFlowTestRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningFlowTestRun {
    if (json == null) {
        return json;
    }
    return {
        
        'screeningTestId': json['screeningTestId'],
        'status': json['status'],
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'minId': json['minId'],
        'maxId': json['maxId'],
        'createdTime': (new Date(json['createdTime'])),
        'startedTime': json['startedTime'] == null ? undefined : (new Date(json['startedTime'])),
        'durationMs': json['durationMs'] == null ? undefined : json['durationMs'],
        'selectionMode': json['selectionMode'] == null ? undefined : json['selectionMode'],
        'externalEntityIds': json['externalEntityIds'] == null ? undefined : json['externalEntityIds'],
        'fromTime': json['fromTime'] == null ? undefined : (new Date(json['fromTime'])),
        'toTime': json['toTime'] == null ? undefined : (new Date(json['toTime'])),
        'goodlistEnabled': json['goodlistEnabled'] == null ? undefined : json['goodlistEnabled'],
        'useOnlyScreenedEntities': json['useOnlyScreenedEntities'] == null ? undefined : json['useOnlyScreenedEntities'],
    };
}

export function InternalApiScreeningFlowTestRunToJSON(json: any): InternalApiScreeningFlowTestRun {
    return InternalApiScreeningFlowTestRunToJSONTyped(json, false);
}

export function InternalApiScreeningFlowTestRunToJSONTyped(value?: InternalApiScreeningFlowTestRun | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'screeningTestId': value['screeningTestId'],
        'status': value['status'],
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'minId': value['minId'],
        'maxId': value['maxId'],
        'createdTime': value['createdTime'].toISOString(),
        'startedTime': value['startedTime'] == null ? value['startedTime'] : value['startedTime'].toISOString(),
        'durationMs': value['durationMs'],
        'selectionMode': value['selectionMode'],
        'externalEntityIds': value['externalEntityIds'],
        'fromTime': value['fromTime'] == null ? value['fromTime'] : value['fromTime'].toISOString(),
        'toTime': value['toTime'] == null ? value['toTime'] : value['toTime'].toISOString(),
        'goodlistEnabled': value['goodlistEnabled'],
        'useOnlyScreenedEntities': value['useOnlyScreenedEntities'],
    };
}

